import { render } from "./MsgError.vue?vue&type=template&id=4532acc2&scoped=true"
import script from "./MsgError.vue?vue&type=script&lang=js"
export * from "./MsgError.vue?vue&type=script&lang=js"

import "./MsgError.vue?vue&type=style&index=0&id=4532acc2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src130918171/src/app-heineken/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4532acc2"]])

export default __exports__